var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_41400)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.866 0a1.6 1.6 0 100 3.2h1.601V1.6c0-.882-.716-1.599-1.6-1.6zm0 4.267H1.6a1.6 1.6 0 000 3.2h4.266a1.6 1.6 0 100-3.2z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.866a1.6 1.6 0 00-3.2 0v1.6h1.6a1.6 1.6 0 001.6-1.6zm-4.267 0V1.6a1.6 1.6 0 00-3.2 0v4.266a1.6 1.6 0 103.2 0z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 16a1.6 1.6 0 100-3.2h-1.6v1.6a1.6 1.6 0 001.6 1.6zm0-4.267H14.4a1.6 1.6 0 000-3.2h-4.266a1.6 1.6 0 00-.001 3.2z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.133a1.6 1.6 0 003.2 0v-1.6H1.6a1.6 1.6 0 00-1.6 1.6zm4.267 0V14.4a1.6 1.6 0 003.2 0v-4.266a1.6 1.6 0 00-3.2-.001z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_41400"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.75408be0994720c360807d27eb2828a0.svg";
export { ForwardRef as ReactComponent };